export const environment = {
  production: false,
  apiUrl: 'https://trainingministry.azurewebsites.net',
  //apiUrl: 'https://localhost:44320',
  envName: 'local',
  blobUrl: 'https://itimonline.blob.core.windows.net/itim-online',
  itimOnlineUrl: 'https://itim-online-courses.azurewebsites.net/',
  enrollOnline: 'https://onlinecourses.traininginministry.com/course-detail/', //new site publish url
};
